import { Box, Button, DialogContentText } from '@mui/material';
import React, { Fragment, useState } from 'react';
import ErrorDialog from '../error-dialog/ErrorDialog';
import { useSignalREffect } from '../signalr/SignalRContext';
import { ProblemDetails, SimulationEventMessage } from '../types';

const ClassroomError = () => {
  const [error, setError] = useState<ProblemDetails>();
  const [showError, setShowError] = useState(false);

  useSignalREffect(
    SimulationEventMessage.ClassroomError,
    (...args) => {
      const error = args[0] as ProblemDetails;
      setError(error);
      setShowError(true);
    },
    [],
  );

  return (
    <ErrorDialog
      open={showError}
      transition={{ onExited: () => setError(undefined) }}
      message={
        <>
          {error?.title && (
            <DialogContentText color="text.primary" variant="body1" gutterBottom>
              {error.title}
            </DialogContentText>
          )}
          {error?.detail && (
            <DialogContentText color="text.secondary" variant="body1">
              {error.detail}
            </DialogContentText>
          )}
          {error?.errors && (
            <Box component="dl" sx={{ color: 'text.secondary', mt: 4 }}>
              {Object.entries(error.errors).map(([key, val]) => (
                <Fragment key={key}>
                  <dt>{key}</dt>
                  <dd>{val}</dd>
                </Fragment>
              ))}
            </Box>
          )}
        </>
      }
    >
      <Button onClick={() => setShowError(false)}>Dismiss</Button>
    </ErrorDialog>
  );
};

export default ClassroomError;
